import { useMutation } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { MessageActionType } from '../types';
import { updateEmployeeMessageTask } from 'RestAPIs/employees/messages';

export const useUpdateEmployeeMessageTask = () => {
  const { mutateAsync, isLoading } = useMutation(
    (variables: { taskId: string | number; actionType: MessageActionType }) =>
      updateEmployeeMessageTask(variables),
    {
      onSuccess: () => showSuccessSnackbar(),
      onError: () => showErrorSnackbar()
    }
  );

  return { mutateAsync, isLoading };
};

export default useUpdateEmployeeMessageTask;
